import { render, staticRenderFns } from "./NewsEcharts.vue?vue&type=template&id=6f6c69d2"
import script from "./NewsEcharts.vue?vue&type=script&lang=js"
export * from "./NewsEcharts.vue?vue&type=script&lang=js"
import style0 from "./NewsEcharts.vue?vue&type=style&index=0&id=6f6c69d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports